import { MutationTree, Mutation } from "vuex";
import { IState, ISearchResult } from "./state";
import { ActionPayload } from "./actions";

type MutationHandler<PayloadType> = (
  state: IState,
  payload: ActionPayload<PayloadType>
) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
  Object.assign(state, payload);
};

const increasePageMutation: MutationHandler<IState> = (state, { payload }) => {
  Object.assign(state, { currentPage: state.currentPage + 1 });
};

const setSearchResultMutation: MutationHandler<ISearchResult> = (
  state,
  { payload }
) => {
  state.searchResult = payload;
};

const mutations: MutationTree<IState> = {
  setState: setStateMutation,
  setSearchResult: setSearchResultMutation,
  increasePage: increasePageMutation,
};

export default mutations;
